import React, { useState } from 'react'
import { useSalesHistoryConfig } from '../../hooks/SalesHistoryConfigContext';
import { useStorefrontSettings } from '../../hooks/StorefrontSettingsContext';
import SalesReportFilters from './SalesReportFilters';
import CustomerService from '../../services/Customer';
import Loading from '../Loading';
import Money from '../Money';
import NotificationBanner from '../banner/NotificationBanner';

function SalesReport(props) {
    const salesHistoryConfig = useSalesHistoryConfig();
    const storefrontSettings = useStorefrontSettings();
    const localized = salesHistoryConfig.labels;
    const [fetching, setFetching] = useState(false);
    const [salesData, setSalesData] = useState([]);
    const [grandTotalArray, setGrandTotalArray] = useState([]);
  
    const fetchSalesByCompany = (selectedCustomer, fromFullDate, toFullDate) => {
        setGrandTotalArray([]);
        setSalesData([]);
        setFetching(true);
        const customerParam = selectedCustomer === '' ? null : (selectedCustomer ?? null);
        CustomerService.getSalesByCompany(fromFullDate, toFullDate, customerParam, loadingData)
    };

    const loadingData = (response) => {
        if (response) {
            if (response?.length > 0) {
                setSalesData(response)
                calculateGrandTotals(response);
            }
        }
        setFetching(false);
    };

    const calculateGrandTotals = (response) => {
        let calculatedGrandTotalArray = [];
        response.forEach(item => {
            if (calculatedGrandTotalArray.findIndex(e => e.currencyCode == item.currencyCode) === -1) {
                calculatedGrandTotalArray.push({ "currencyCode": item.currencyCode, "total": item.totalSales, "countryCode": item.countryCode })
            }
            else {
                let addIndex = calculatedGrandTotalArray.findIndex(e => e.currencyCode == item.currencyCode);
                calculatedGrandTotalArray[addIndex].total += item.totalSales;
            }
        });
        setGrandTotalArray(calculatedGrandTotalArray);

    };

    const renderSalesReportFilters = () => {
        return (
            <SalesReportFilters fetchSalesReport={fetchSalesByCompany} />);
    };

    const renderSalesHeaders = () => {
        return (
            <>
                <NotificationBanner
                    classOverride="mb-4"
                    page="SalesReport"
                    locale={storefrontSettings.locale}
                />

                <div className="display-2 d-flex" style={{ marginBottom: '50px' }}>
                    <b className='title'>{localized.SalesReport || 'Sales'}</b>
                </div>
                <div className="seperator"></div>
            </>
        );
    };

    const renderSalesGrid = () => {
        return (
            <>
                {renderSalesGridHeader()}
                {
                    fetching &&
                    <Loading type="brand" />
                }
                {
                    !fetching && (salesData && salesData.length === 0) &&
                    <div data-cy="report-details-no-results" className="details no-result">
                        {localized.NoSalesHistoryFound}
                    </div>
                }
                {!fetching && (salesData && salesData.length > 0) && renderSalesData()}
                {renderSalesGridFooter()}
            </>
        );
    };

    const renderSalesGridHeader = () => {
        return (
            <div className="br-history-header">
                <div className="br-item-name">
                    <div className="label">{localized.CustomerShip}</div>
                </div>
                <div className="br-item-name">
                    <div className="label">{localized.Sales}</div>
                    <div className="fele-content">
                        {localized.HistoryPriceTax}
                    </div>
                </div>
            </div>
        );
    };

    const renderSalesData = () => {
        return (
            <div data-cy="history" className="br-history">
                {salesData.map((item, key) => renderSalesHistoryRowData(item, key))}
            </div>
        );
    };

    const renderSalesHistoryRowData = (sales, index) => {
        return (
            <div className="br-details" key={index}>
                <div className="br-item-name">
                    <div className="fele-content">{`${sales.customerName} [${sales.addressBookNumber}]`}</div>
                </div>
                <div className="br-item-description">
                    <div className="fele-content">
                        <Money value={sales.totalSales} currency={sales.currencyCode} country={sales.countryCode} />
                    </div>
                </div>
            </div>
        )
    };

    const renderSalesGridFooter = () => {
        return (
            <div>
                {grandTotalArray.map((item, key) => renderGrandTotalSalesRowData(item, key))}
            </div>
        );
    };

    const renderGrandTotalSalesRowData = (sales, index) => {
        return (
            <div className="br-history-header" key={index}>
                <div className="br-item-name" style={{ textAlign: 'right', paddingRight: '2%' }}>
                    <div className="label">{sales.currencyCode} {localized.TotalSales}: </div>
                </div>
                <div className="br-item-description">
                    <div className="fele-content">
                        <Money value={sales.total} currency={sales.currencyCode} country={sales.countryCode} />
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div data-cy="report-order-history" className="fele-order-history">
            {renderSalesHeaders()}
            {renderSalesReportFilters()}
            {renderSalesGrid()}
        </div>
    )
}

export default SalesReport;